export const routes = (prefix = `auditing`) => [
    {
        name: `${prefix}.inpatient.index`,
        path: `/${prefix}/inpatient`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.inpatient.index`,
                PageDescription: "Audits - Inpatient",
            },
        },
    },
    {
        name: `${prefix}.inpatient.head-counts.print`,
        path: `/${prefix}/inpatient/head-counts/print`,
        component: () => import('./head-count/prints/HeadCountSessions.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.inpatient.index`,
                PageDescription: "Audits - Inpatient",
            },
        },
    },
    {
        name: `${prefix}.inpatient.head-count-details.print`,
        path: `/${prefix}/inpatient/head-count-details/print`,
        component: () => import('./head-count/prints/HeadCountDetails.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.inpatient.index`,
                PageDescription: "Audits - Inpatient",
            },
        },
    },
];
